import enCards from './en';
import ruCards from './ru';

export default {
  en: {
    ...enCards,
  },
  ru: {
    ...ruCards,
  },
};
